export const emailRules = (empty: string, format: string): any[] => [
  (v: string) => !!v || empty,
  (v: string) => /.+@.+/.test(v) || format,
];

export const passwordRules = (empty: string, length: string): any[] => [
  (v: string) => !!v || empty,
  (v: string) => v.length >= 7 || length,
];

export const requiredRule = (empty: string): any[] => [
  (v: string) => !!v || empty
];

export const nonEmpty = (empty: string): any[] => [
  (v: string) => v != "" || empty
];

export const phoneRules = (empty: string, format: string): any[] => [
  (v: string) => !!v || empty,
  (v: string) => /^((\+)33|0|0033)[1-9](\d{2}){4}$/g.test(v) || format
];



